import railsData from '../rails-data';

export const HELP_URL = 'https://help.shopify.com';
export const DEVELOPERS_URL = 'https://developers.shopify.com';
export const FORUMS_URL = 'https://community.shopify.com';

const HASH_REGEX = /#(.[^?]+)/;

function getOriginalHash(baseUrl, subtree = '') {
  const hash =
    (subtree && subtree.match(HASH_REGEX)) || baseUrl.match(HASH_REGEX);

  if (hash) {
    return hash[0];
  }

  return '';
}

export function urlLocalizer(baseUrl, subtree = '', options = {}) {
  const locale = railsData('locale');

  const originalHash = getOriginalHash(baseUrl, subtree);
  const url = new URL(subtree, baseUrl);

  url.hash = options.hash ? `#${options.hash}` : originalHash;

  const searchParams = new URLSearchParams(url.search);

  searchParams.set('locale', locale);

  url.search = searchParams.toString();
  return url.toString();
}

export function helpUrlLocalizer(path, options) {
  return urlLocalizer(HELP_URL, path, options);
}

export function developersUrlLocalizer(path, options) {
  return urlLocalizer(DEVELOPERS_URL, path, options);
}

export function forumsUrlLocalizer() {
  const locale = railsData('locale');
  const url = new URL(`/c/Shopify-Community/ct-p/${locale}`, FORUMS_URL);
  return url.toString();
}
